interface MetaData {
  hid: string
  name?: string
  content: string
  property?: string
}

export const useGenerateSeoMeta = (
  title: string,
  description: string,
  robots: string
): Array<MetaData> => {
  return [
    {
      hid: 'description',
      name: 'description',
      content: description,
    },
    {
      hid: 'og:title',
      name: 'og:title',
      content: title,
    },

    {
      hid: 'og:description',
      property: 'og:description',
      content: description,
    },
    {
      hid: 'robots-1',
      name: 'robots',
      content: robots,
    },
  ]
}
